// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DTiko","tabsBox":"styles_tabsBox__30Bgi","createButton":"styles_createButton__qqDtY"};